var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "template-card",
      class: { selected: _vm.selected },
      on: { click: _vm.onClick },
    },
    [
      _c("div", { staticClass: "first" }, [
        _c("span", { staticClass: "slug" }, [
          _vm._v(_vm._s(_vm.formatedTemplate.name)),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c(
              "a-popconfirm",
              {
                attrs: {
                  placement: "topRight",
                  "ok-text": _vm.$t("whatsapp.yes"),
                  "cancel-text": _vm.$t("whatsapp.no"),
                },
                on: { confirm: _vm.deleteAction },
              },
              [
                _c("template", { slot: "title" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("whatsapp_business_api.sureDeleteTemplate"))
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "IconButton",
                  [_c("a-icon", { attrs: { type: "delete" } })],
                  1
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c("IconButton", [_c("a-icon", { attrs: { type: "eye" } })], 1),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "second" }, [
        _c("div", { staticClass: "headers" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.$t("whatsapp_business_api.templateInfo"))),
          ]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("wp.description")))]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("message.status")))]),
          _vm._v(" "),
          _c("span"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "cells" }, [
          _c("div", { staticClass: "cell cell1" }, [
            _c("div", { staticClass: "info-item" }, [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("whatsapp_business_api.category")) + " :"),
              ]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.formatedTemplate.category))]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info-item" }, [
              _c("label", [_vm._v(_vm._s(_vm.$t("settings.language")) + " :")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.formatedTemplate.language))]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info-item" }, [
              _c("label", [_vm._v(_vm._s(_vm.$t("message.type")) + " :")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.formatedTemplate.type))]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info-item" }, [
              _c("label", [_vm._v("ID:")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.formatedTemplate.id))]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cell cell2" }, [
            _c("span", [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.formatedTemplate.data) +
                  "\n                "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cell cell3" }, [
            ["FAILED", "REJECTED"].includes(_vm.formatedTemplate.status)
              ? _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { followCursor: true, placement: "bottom-end" },
                        expression:
                          "{ followCursor: true, placement: 'bottom-end' }",
                      },
                    ],
                    attrs: { content: _vm.formatedTemplate.reason },
                  },
                  [
                    _vm._v(
                      "\n                    🔴 " +
                        _vm._s(_vm.$t("whatsapp_business_api.rejectWhatsapp")) +
                        "\n                "
                    ),
                  ]
                )
              : _vm.formatedTemplate.status === "PENDING"
              ? _c("span", [
                  _vm._v(
                    "🟡 " +
                      _vm._s(_vm.$t("whatsapp_business_api.pendingWhatsapp")) +
                      "\n                "
                  ),
                ])
              : _c("span", [
                  _vm._v(
                    "🟢 " +
                      _vm._s(_vm.$t("whatsapp_business_api.approvedWhatsapp"))
                  ),
                ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cell cell4" }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }